<script>
  import BaseChart  from './ChartBase';
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'DashboardProsChart',
    
    extends: BaseChart,

    computed: { 
      ...mapGetters('dashboards', { dataset: 'byPro'})
    },

    methods: {
      ...mapActions('dashboards', { load: 'loadByPro' }),
    },
  }
</script>
